import firebase from 'firebase/app';
import { useState } from 'react';
import '../config/initializeApp';

export function useFirestore() {
  const [firestore] = useState(() => firebase.firestore());
  return firestore;
}
